import Link from "next/link";
import Image from "next/image";
import styles from "./PostMeta.module.scss";

export default function PostMeta({ post }) {
  const {
    publishedAt,
    updatedAt,
    date_created,
    createdAt,
    author,
    region,
    country,
  } = post;

  return (
    <div className={`${styles.postMeta}`}>
      <div className={`${styles.backArrow}`}>
        <Link href="/stories">
          <Image
            src="/assets/img/icons/arrow_back.svg"
            alt="Back arrow icon"
            width={37}
            height={35}
            layout="fixed"
          />
        </Link>
      </div>
      <h1 className={`${styles.title}`}>{post?.title}</h1>
      <div className={`${styles.metadata}`}>
        <div className={`${styles.date}`}>
          <p>
            {date_created !== undefined && !!date_created
              ? date_created
              : publishedAt}{" "}
            | {author?.authorName || "Unknown"}{" "}
          </p>
          <p className={`${styles.updatedAt}`}>
            Updated on {!!updatedAt ? updatedAt : ""}
          </p>
        </div>

        <p className={`${styles.readTime}`}>
          {post?.read_time_in_mins || 5}-min read
        </p>
      </div>
      {region?.region && country?.country && (
        <div className={`${styles.location}`}>
          <p>
            {region?.regionName && (
              <>
                <Link href={`/destinations/${region?.region}`}>
                  {region?.regionName}
                </Link>{" "}
                |{" "}
              </>
            )}
            {country?.countryName && (
              <Link
                href={`/destinations/${region?.region}/${country?.country}`}
              >
                {country?.countryName}
              </Link>
            )}
          </p>
        </div>
      )}
    </div>
  );
}
